export class ClientData {
  public static CLIENT_TYPES = ['Domestic', 'International'];

  public static PACKAGES = [
    { id: '1 Month', value: '1 Month' },
    { id: '3 Months', value: '3 Months' },
    { id: '6 Months', value: '6 Months' },
  ];

  public static PACKAGE_AMOUNT = [
    {
      id: 'Domestic',
      value: [
        { id: '1 Month', value: 4999 },
        { id: '3 Months', value: 8499 },
        { id: '6 Months', value: 16999 },
      ],
    },
    {
      id: 'International',
      value: [
        { id: '1 Month', value: 4999 },
        { id: '3 Months', value: 8499 },
        { id: '6 Months', value: 16999 },
      ],
    },
  ];
}
